


























































































































































import {
  checklistPostReq
} from "@/services/checklist.service";


export default  {
  props: ['cl_item'], 
  data() {
    return {
      create_progress: false,
      checklist_dialog: {},
      create_error: false, 
      database_entry: "inspect-common", 
      cl_entry: {}, 
      view_mode: 'database',
      versions: [
        'Minor Version',
        'Major Version'
      ],
      databases: [
        //'checklisten-dev',
        //'inspect-common-debug',
        'inspect-common'
      ],
    }
  },
  watch: {

  },
  computed: {
    appLang: function() {
      return this.$store.state.lang
    },
  },
  mounted() {
   this.chooseDatabase()
  },
  destroyed() {
  },
  methods: {
    closeDialog: function () {
      this.$emit("dialogClosed", true);
    },
    chooseDatabase: function () {


      if (this.database_entry.length > 2) {
        this.create_progress = true
        this.view_mode = 'form'
        this.create_error = false
        checklistPostReq('couchdb-getchecklist', { uid: this.cl_item.uid, database: this.database_entry }) 
          .then(resp => {
            this.create_progress = false
            this.cl_entry = resp.item
     
          })
          .catch(e => {
            this.$store.dispatch("api_error", e);
        });  
      }
      else {
        this.create_error = true
      }
    },
    save: function () {
      this.create_error = false
      if (!this.cl_entry.version ) {
        this.create_error = true
      } else {
         this.create_progress = true
      
          checklistPostReq('couchdb-transferchecklist', { database: this.cl_entry.database, 
                                                          version: this.cl_entry.version, 
                                                          comment: this.cl_entry.comment, 
                                                          uid: this.cl_item.uid, 
                                                          rev: this.cl_entry._rev }) 
            .then(resp => {
              console.log(resp)
              this.$emit("dialogClosed", true);
            })
            .catch(e => {
              this.$store.dispatch("api_error", e);
          }); 

      }
    }
   
  }
}

